
import { ISDKInfo } from './interfaces';

export const sdkInfo: ISDKInfo = {
    host: 'npmjs.com',
    version: '1.0.4',
    name: 'banjo-kentico-cloud-delivery'
};
